package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import core.dateformat.utils.formatTimestampToHHMM
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryEvent
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryNavigation
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.uikit.components.image.AsyncUrlIcon
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ItineraryServiceCard(
    itineraryService: ItineraryServiceModel,
    service: ServiceModel,
    category: CategoryModel,
    onEvent: (EditItineraryEvent) -> Unit,
    onNavigation: (EditItineraryNavigation) -> Unit,
    modifier: Modifier = Modifier,
    confirmed: Boolean,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
            .clickable(
                enabled = !confirmed,
            ) {
                onNavigation(EditItineraryNavigation.EditItineraryService(itineraryService))
            }
            .background(MaterialTheme.esColorScheme.bgPrimary)
            .padding(
                vertical = 12.dp,
                horizontal = 16.dp,
            )
            .fillMaxWidth(),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center,
        ) {
            if (!category.iconUrl.isNullOrBlank()) {
                AsyncUrlIcon(
                    url = category.iconUrl ?: "",
                    contentDescription = category.name,
                    tint = Color(0xFF8985A2),
                    modifier = Modifier
                        .size(24.dp),
                )

                Spacer(modifier = Modifier.width(1f.spacing))
            }
            Column(
                modifier = Modifier
                    .align(Alignment.CenterVertically)
                    .padding(start = 1.spacing),
            ) {
                Text(
                    modifier = Modifier
                        .fillMaxWidth(0.6f),
                    text = service.title,
                    color = MaterialTheme.esColorScheme.textPrimary,
                    style = MaterialTheme.esTypography.s2SemiBold16,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
                Text(
                    text = itineraryService.supplier?.prettyName ?: "No supplier selected",
                    color = MaterialTheme.esColorScheme.textTertiary,
                    style = MaterialTheme.esTypography.p1Regular16,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
            }
        }

        itineraryService.startTime?.let { t ->
            Text(
                text = formatTimestampToHHMM(t),
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.p2Medium14,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier
                    .clip(shape = RoundedCornerShape(5.dp))
                    .clickable {}
                    .padding(0.5.spacing),
            )
        } ?: ""

        itineraryService.status?.let {
            ItineraryServiceStatusDropDown(
                status = it,
                onStatusSelected = { newStatus ->
                    if (newStatus != itineraryService.status)
                        onEvent(
                            EditItineraryEvent.UpdateItineraryServiceStatus(
                                itineraryService,
                                newStatus,
                            ),
                        )
                },
            )
        }
    }
}
